export default {"src":"/_next/static/media/close.aaf4038b.svg","height":24,"width":24};